import { Reasons } from './Reasons/Reasons';

export default class Environment {
    init(environmentCheckerResult) {
        console.log('environment init');
        this.environmentCheckerResult = environmentCheckerResult;
        this.detectorResult = environmentCheckerResult.detectorResult;

        this.checksPassed = environmentCheckerResult.checksPassed;

        this.platformType = this.detectorResult.platform.type.toLowerCase();
        this.isMobile = this.platformType === 'mobile' || this.platformType === 'tablet';
        this.isMobileSize = this.platformType === 'mobile';
        this.isTabletSize = this.platformType === 'tablet';

        this.browserName = this.detectorResult.browser.name.toLowerCase();
        this.isSafari = this.browserName === 'safari';
        this.isEdge = this.browserName === 'microsoft edge';
        this.isChrome = this.browserName === 'chrome' || this.browserName === 'android webview' || this.browserName === 'firefox';

        this.isIOS = this.detectorResult.os.name.toLowerCase() === 'ios' || this.detectorResult.os.name.toLowerCase() === 'macos' || this.detectorResult.os.name.toLowerCase() === 'mac_os';

        this.operatingSystemName = this.detectorResult.os.name;

        this.browserMajorVersion = this.detectorResult.browser.version?.substr(0, 2);
    }

    getErrorReason() {
        let error, reason;
        let retry = false;
        switch (this.environmentCheckerResult.failureReasonCode) {
            case Realeyesit.EnvironmentalDetectionAPI.failureReasonCodes.BROWSER_NOT_CAPABLE:
                reason = Reasons.incompatible_browser;
                break;
            case Realeyesit.EnvironmentalDetectionAPI.failureReasonCodes.DESKTOP_BROWSER:
                reason = Reasons.desktop_browser;
                break;
            case Realeyesit.EnvironmentalDetectionAPI.failureReasonCodes.TABLET_BROWSER:
                reason = Reasons.tablet_browser;
                break;
            case Realeyesit.EnvironmentalDetectionAPI.failureReasonCodes.MOBILE_BROWSER:
                reason = Reasons.mobile_browser;
                break;
            case Realeyesit.EnvironmentalDetectionAPI.failureReasonCodes.NO_WEBCAMS_DETECTED:
                reason = Reasons.no_webcam;
                break;
            case Realeyesit.EnvironmentalDetectionAPI.failureReasonCodes.OTHER_ERROR:
                reason = Reasons.cannot_load_flash;
                retry = true;
                break;
            case Realeyesit.EnvironmentalDetectionAPI.failureReasonCodes.IOS_WEBVIEW:
                reason = Reasons.ios_webview;
                break;
            case Realeyesit.EnvironmentalDetectionAPI.failureReasonCodes.BLACKLISTED:
                reason = Reasons.blacklisted;
                break;
            default:
                reason = Reasons.error_uncaught_exception;
                break;
        }
        error = { reason: reason, retry: retry };
        return error;
    }
}